import { Container, Stack } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './footer/footer.component';
import Header from './header/header.component';

const theme = createTheme({
    typography: {
        allVariants: {
            fontFamily: "'Montserrat', sans-serif"
        }
    },
    palette: {
        primary: {
            main: '#002A4D'
        },
        green: {
            main: '#4CA341'
        },
        yellow: {
            main: '#FFAE07'
        },
        red: {
            main: '#DA1F33'
        },
        white: {
            main: '#FFFFFF'
        }
    }
});

const pageContent = {
    style: {
        height: '100%'
    }
};

const PageLayout = () => {
    return (
        <Container sx={{ fontFamily: "'Montserrat', sans-serif" }} disableGutters maxWidth={false}>
            <ThemeProvider theme={theme}>
                <div className="wrapper-page">
                    <Stack direction={'column'}>
                        <Header />
                        <div style={pageContent.style}>
                            <Outlet />
                        </div>
                    </Stack>
                    <Footer />
                </div>
            </ThemeProvider>
        </Container>
    );
};

export default PageLayout;
